var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { useMemo, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { destroy, getFormValues } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiCreateClientInterview, apiGetOneClientRfp, } from '../../../../actions/ClientRfpActions';
import { notify, wrapDispatch, wrapNotifyError, } from '../../../../helpers/action';
import { propShape } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import RfpPageTitle from '../../../Ui/Rfp/RfpPageTitle';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import InterviewInputFormConfirm from './Parts/InterviewInput/InterviewInputFormConfirm';
import RfpOneSkeleton from './RfpOneSkeleton';
const RfpOneInterviewConfirm = (props) => {
    const { rfp } = props;
    const { id, name } = rfp;
    const history = useNavigate();
    const pans = useMemo(() => [
        {
            link: '/mypage/project',
            text: 'マイページ',
        },
        {
            link: `/project/client/${id}/interview/view`,
            text: name,
        },
        {
            text: '面談日程を決める',
        },
    ], [id, name]);
    const title = '面談日程を決める';
    const formName = `InterviewInputForm_${id}`;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const formValues = useSelector((state) => getFormValues(formName)(state));
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            // api実行
            const { isEntrust } = values, addValue = __rest(values, ["isEntrust"]);
            const action = apiCreateClientInterview(id, Object.assign(Object.assign({}, addValue), { interviewCandidates: isEntrust
                    ? []
                    : (values.interviewCandidates || []).map((v) => (Object.assign(Object.assign({}, v), { interviewDate: moment(v.interviewDate).format('YYYY-MM-DD') }))), viewRequestId: values.viewRequestId.map((v) => v.id) }));
            yield wrapDispatch(dispatch, action);
            yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
            yield history.push(`/project/client/${id}/interview/view`);
            notify('面談依頼を申し込みました');
        }));
    }), [dispatch, history, id]);
    useEffect(() => () => {
        if (window.location.pathname !== `/project/client/${id}/interview/input`) {
            dispatch(destroy(formName));
        }
    }, [id, formName, dispatch]);
    if (!formValues) {
        return (_jsx(CustomRedirect, { to: `/project/client/${id}/interview/input${search}` }));
    }
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container is_interview_input' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${name} ${title}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpPageTitle, { text: name }), _jsx("div", Object.assign({ className: 'rfp_container' }, { children: _jsx("div", Object.assign({ className: 'rfp_content' }, { children: _jsxs("div", Object.assign({ className: 'rfp_content_main' }, { children: [_jsx("div", Object.assign({ className: 'rfp-card is-rfp' }, { children: _jsx("div", Object.assign({ className: 'rfp-card-head align-center' }, { children: _jsx("span", { children: title }) })) })), _jsx("div", Object.assign({ className: 'rfp-card-body' }, { children: _jsx(InterviewInputFormConfirm, { form: formName, formValues: formValues, id: id, onSubmit: onSubmit }) }))] })) })) }))] })));
};
RfpOneInterviewConfirm.propTypes = {
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({
    redirectCallback: ({ offers, rfp }) => {
        const isEnable = offers.length > 0;
        return !isEnable && `/project/client/${rfp.id}`;
    },
}, RfpOneSkeleton));
export default enhance(RfpOneInterviewConfirm);
